import { HttpClient } from 'common/services/http-client.service';
import { getArchiveList } from 'assets/data/dataList';
import { PagedRequest } from 'common/models/data/pagedRequest.model';
import { PaginatedApiResponse } from 'common/models/api-service/api-response.model';
import { ApiResult } from 'common/models';
import { Entity } from 'common/models/data/entity.model';
import { IErrorApiResponse } from 'common/models/api-service/error-response.model';
import archiveApiConfig from './archive.config';
import { EntityType } from 'common/enums';
import masterDataApiConfig from 'modules/master-data/redux/masterData.config';

export class ArchiveService extends HttpClient {
    public static async fetchArchiveList(pagedRequest: PagedRequest) {
        return ArchiveService.invokeApi(archiveApiConfig.getArchivedCategoriesUrl(pagedRequest));
    }

    public static deleteArchiveData(id: string, entityType: EntityType) {
        switch (entityType) {
            case EntityType.Category:
                return ArchiveService.invokeApi<any>(archiveApiConfig.deleteArchivedCategory(id));
            case EntityType.SubCategory:
                return ArchiveService.invokeApi<any>(
                    archiveApiConfig.deleteArchivedSubCategory(id)
                );
            case EntityType.Indicator:
                return ArchiveService.invokeApi<any>(archiveApiConfig.deleteArchivedIndicator(id));
        }
    }

    public static getSearchList(payload: any) {
        if (payload.includeSubCategory) {
            return [
                {
                    id: 3,
                    name: 'Population',
                    path: ['Country essentials'],
                    entityType: 'SubCategory',
                    hasChild: false,
                    hasIndicator: false
                }
            ];
        } else if (payload.includeIndicators) {
            return [
                {
                    id: 1,
                    name: 'Population growth',
                    path: ['Country essentials', 'Population'],
                    entityType: 'Indicator'
                },
                {
                    id: 2,
                    name: 'Population median age',
                    path: ['Country essentials', 'Population'],
                    entityType: 'Indicator'
                }
            ];
        } else if (payload.includeCategory) {
            return [];
        } else {
            return [
                {
                    id: 1,
                    name: 'Population growth',
                    path: ['Country essentials', 'Population'],
                    entityType: 'Indicator'
                },
                {
                    id: 2,
                    name: 'Population median age',
                    path: ['Country essentials', 'Population'],
                    entityType: 'Indicator'
                },
                {
                    id: 3,
                    name: 'Population',
                    path: ['Country essentials'],
                    entityType: 'SubCategory',
                    hasChild: true,
                    hasIndicator: true
                }
            ];
        }
    }

    public static getEntityDetails(payload: any) {
        return {
            hasError: false,
            errors: [],
            value: {
                name: payload.name,
                dateAdded: '2023-06-02T10:37:32.7766667',
                editedUser: 'pl_Core_to_Temp_latest',
                lastModified: '2023-06-02T10:37:32.7766667',
                mappedto: null
            }
        };
    }

    public static async getCategories(
        pagedRequest: PagedRequest,
        entityId?: string,
        type?: string
    ): Promise<ApiResult<PaginatedApiResponse<Entity[]> | IErrorApiResponse> | undefined> {
        return ArchiveService.invokeApi<PaginatedApiResponse<Entity[]> | IErrorApiResponse>(
            masterDataApiConfig.getCategoriesUrl(pagedRequest, entityId, type)
        );
    }

    public static async getEntitiesById(
        entityId: string,
        entityType: EntityType
    ): Promise<ApiResult<Entity[] | IErrorApiResponse> | undefined> {
        return ArchiveService.invokeApi<Entity[] | IErrorApiResponse>(
            archiveApiConfig.getEntitiesByIdUrl(entityId, entityType)
        );
    }
    public static restore(payload: any) {
        switch (payload.entityType) {
            case EntityType.Category:
                return ArchiveService.invokeApi<number>(
                    archiveApiConfig.restoreCategoryUrl(payload)
                );
            case EntityType.SubCategory:
                return ArchiveService.invokeApi<number>(
                    archiveApiConfig.restoreSubCategoryUrl(payload)
                );
            case EntityType.Indicator:
                return ArchiveService.invokeApi<number>(
                    archiveApiConfig.restoreIndicatorUrl(payload)
                );
        }
    }
    public static fetchArchiveListBySearch(payload: any) {
        return ArchiveService.invokeApi<number>(archiveApiConfig.fetchArchiveListBySearch(payload));
    }
}
